import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import useSafeEffect from "hooks-contexts/useSafeEffect";
import { useEffect, useRef, useState } from "react";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "../new-product-filter.module.scss";

function FilterDropdown(props: any) {
  const {
    title, index, children, icon,
    filterKey, setSearchText,
  } = props;
  const imgSrc = getRelativeImagePath(icon);

  const ref = useRef<HTMLDivElement>(null);

  const [expanded, setIsExpanded] = useState(false);

  useEffect(() => {
    // Reset search filter when dropdown is closed
    if (!expanded) {
      setSearchText("");
    }
  }, [expanded]);

  function handleClickOutside(event: MouseEvent): void {
    if (["bucket-checkbox", "bucket-label"].includes(event?.target?.className)
    || ["filter-checkbox", "filter-checkbox-span"].includes(event?.target?.id)) {
      return;
    }
    if (ref.current && !(ref.current.contains(event?.target))) {
      setIsExpanded(false);
    }
  }

  const isMerchSizeFilter = filterKey === "merchandiseSizes";

  useSafeEffect(() => {
    document.addEventListener("mousedown", handleClickOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={classNames(`${styles.relative_position}`, {
        "m-l-10": index !== 0,
      })}
    >
      <div
        className={classNames(styles.option, {
          "m-l-0": index === 0,
          "p-l-30": isMerchSizeFilter,
        })}
        onClick={() => { setIsExpanded(!expanded); }}
      >
        <HideIf show={icon}>
          <PAImage
            src={imgSrc}
            width={24}
            height={24}
            alt={title}
            className={styles.fitment_icon}
          />
        </HideIf>

        <HideIf show={isMerchSizeFilter}>
          <PAImage
            src={getRelativeImagePath("/images/size_chart_icon.png")}
            width={50}
            height={50}
            alt={title}
            className={`${styles.fitment_icon} ${styles.merch_size_image}`}
          />
        </HideIf>

        <PAText fontSize={FONT_SIZE[2]} color="black">{title}</PAText>
        <i className={`fa fa-angle-${expanded ? "up" : "down"} p-l-5`} aria-hidden="true" />
      </div>
      <HideIf show={expanded}>
        <div className={styles.absolute}>
          {children}
        </div>
      </HideIf>
    </div>
  );
}
export default FilterDropdown;
